angular.module('app.controllers').controller('ExpertsListCtrl', ['$scope', '$rootScope', 'UI', 'APIRead', 'APIReadTable', 'Table'].append(function(self, root, UI, APIRead, APIReadTable, Table) {
  var cookiesName, ref, tableName;
  tableName = 's.experts.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  self.experts = Table({
    name: tableName,
    type: "partial",
    resource: APIReadTable,
    params: {
      limit: 12,
      entry_type: 'experts'
    }
  });
  self.$watch('experts.params', function(newObj, oldObj) {
    return self.page = 1;
  }, true);
  self.page = 1;
  return self.loadMore = function() {
    var params;
    if (self.page >= self.experts.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.experts.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIRead.query(params, function(data) {
      self.more = data;
      self.experts.data.display = self.experts.data.display.concat(self.more);
      return self.moreLoad = false;
    });
  };
}));
